import { getYpaUserData } from '@guestyci/gfh-utils';
import { useQuery } from 'react-query';
import getUserData from 'utils/user';
import { gfhAPI } from '../httpClient';

const defaultOnboardingStatus = {
  welcomeMessageSeen: true,
  items: [],
};

export const fetchOnboardingStatus = async () => {
  const { ypaUserId } = getYpaUserData();

  if (!ypaUserId) {
    // Onboarding status is not available for anonymous users.
    // Return a default object instead of querying the API.
    return Promise.resolve(defaultOnboardingStatus);
  }

  const { data } = await gfhAPI.post('/porter-onboarding/get', {
    userId: ypaUserId,
  });
  if (!data.success) {
    throw new Error(`Failed to load onboarding status: ${data.errorMessage}`);
  }
  return data.onboardingUserStatus;
};

export const useFetchOnboardingStatus = () => {
  const { ypaUserId } = getYpaUserData();
  return useQuery(['onboarding-status', ypaUserId], fetchOnboardingStatus, {
    enabled: !getUserData()?.accountIsSuspended,
  });
};
